<template>
  <div>
  <!-- equity/v2/detail 未完成前的整页 loading -->
  <div v-if="equityDetailLoading" class="service-page-loading">
    <div class="service-page-loading-spinner"></div>
    <div class="service-page-loading-text">加载中...</div>
  </div>
  <div v-else class="service-container" >
    <header class="service-header" :style="{paddingTop: effectiveStatusBarHeight + 'px'}">
      <div class="service-header-top">
        <div class="service-title">服务</div>
        <div class="kefu-wrapper" @click="openCustomerService">
          <img 
            src="@/assets/serviceImg/kefu.png" 
            alt="客服" 
            class="kefu-icon"
          />
          <span class="kefu-text">客服</span>
        </div>
    </div>
      <!-- <div class="service-header-content">
      </div> -->
      <!-- 悬浮一键救援按钮 -->
      <div 
        v-if="currentPosition > 90 && !showRightsDialog && !showPrivateDoctorDialog" 
        class="heartbeat rescue-float-btn" 
        @click="actionCallHelp()" 
      >
        <div class="rescue-btn-icon"
        style="margin-bottom: 10px;">
          <span class="rescue-icon-heart">一 键</span>
        </div>
        <div class="rescue-btn-icon">
          <span class="rescue-icon-heart">救 援</span>
        </div>
        <!-- <div class="rescue-btn-text">救援</div> -->
      </div>
      <!-- 一键救援卡片 -->
      <div class="rescue-card-container">
        <!-- 圆形图标区域 -->
        <div class="rescue-icon-wrapper">
          <img src="@/assets/serviceImg/service/00d700a6397f85c7d4c48bdf4ece20cbc85fea12f55a-En0Urw_fw1200_1@2x.png" alt="实时安全保护" class="rescue-icon" />
      </div>
        <!-- 实时安全保护中文字 -->
        <div class="rescue-status-text">实时安全保护中</div>
        <!-- 一键救援按钮 -->
        <div class="rescue-button-wrapper" @click="actionCallHelp()">
          <img src="@/assets/serviceImg/service/Rectangle_346241932@2x.png" alt="一键救援" class="rescue-button-bg" />
          <div class="rescue-button-text">一键救援</div>
      </div>
        <!-- 描述文字 -->
        <div class="rescue-desc-text">24小时人工在线, 一键救援, 精准定位</div>
      </div>
    </header>
      <!-- 在线医生模块 -->
      <div class="online-doctor-module">
        <!-- 标题区域 -->
        <div class="doctor-module-header">
          <div class="doctor-module-title">
            <span class="titspan">在线医生  <span class="doctor-time">24小时</span></span>
          
        </div>
      </div>
      
        <!-- 卡片区域 -->
        <div class="doctor-cards-wrapper">
          <!-- 图文医生 - 左侧大卡片 -->
        <div class="doctor-main-card" @click="handleGraphicDoctorClick">
            <img src="@/assets/serviceImg/service/Frame_4268@2x.png" alt="图文医生" class="doctor-main-card-bg" />
            <div class="doctor-main-card-content">
            <div class="doctor-main-info">
              <div class="doctor-type">图文医生</div>
                <div class="doctor-specialty">
                  <span class="doctor-checkmark green-checkmark">✓</span>
                  全科
            </div>
                <div class="doctor-action-btn green-btn">
                  去咨询
                  <img src="@/assets/serviceImg/service/Frame@2x (2).png" alt="箭头" class="doctor-btn-arrow" />
                </div>
            </div>
          </div>
        </div>
        
          <!-- 右侧两个小卡片 -->
          <div class="doctor-right-cards">
            <!-- 视频医生 - 右上角 -->
            <div class="doctor-card" @click="handleVideoDoctorClick">
              <img src="@/assets/serviceImg/service/Frame_4266@2x.png" alt="视频医生" class="doctor-card-bg" />
            <div class="doctor-card-content">
              <div class="doctor-card-info">
                  <div class="doctor-card-type">视频医生</div>
                  <div class="doctor-card-specialty">
                    <span class="doctor-checkmark blue-checkmark">✓</span>
                    全科
                  </div>
                  <div class="doctor-action-btn blue-btn">
                    去咨询
                    <img src="@/assets/serviceImg/service/Frame@2x (2).png" alt="箭头" class="doctor-btn-arrow" />
                  </div>
              </div>
            </div>
          </div>
          
            <!-- 电话医生 - 右下角 -->
            <div class="doctor-card" @click="handlePhoneDoctorClick">
              <img src="@/assets/serviceImg/service/Frame_4269@2x.png" alt="电话医生" class="doctor-card-bg" />
            <div class="doctor-card-content">
              <div class="doctor-card-info">
                  <div class="doctor-card-type">电话医生</div>
                  <div class="doctor-card-specialty">
                    <span class="doctor-checkmark blue-checkmark">✓</span>
                    全科
                  </div>
                  <div class="doctor-action-btn blue-btn">
                    去咨询
                    <img src="@/assets/serviceImg/service/Frame@2x (2).png" alt="箭头" class="doctor-btn-arrow" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 私人医生一对一解答 -->
      <div class="private-doctor-banner" v-if="showPrivateDoctorCard" @click="showPrivateDoctorGroup">
        <img src="@/assets/serviceImg/service/Rectangle_806@2x.png" alt="卡片背景" class="private-doctor-bg" />
        <div class="private-doctor-content">
          <img src="@/assets/serviceImg/service/5d9b101dff0154d0575f9c6089a1f56c23cd1e5e7203-FPxWES_fw1200_1@2x.png" alt="医生图片" class="private-doctor-doctor-img" />
          <div class="private-doctor-info">
            <div class="private-doctor-title">私人医生一对一解答</div>
            <div class="private-doctor-desc">成为您的私人医生管家</div>
          </div>
          <div class="private-doctor-btn-wrapper" @click.stop="showPrivateDoctorGroup">
            <img src="@/assets/serviceImg/service/Rectangle_808@2x.png" alt="按钮背景" class="private-doctor-btn-bg" />
            <div class="private-doctor-btn-text">
              去查看
              <img src="@/assets/serviceImg/service/Frame@2x(4).png" alt="箭头" class="private-doctor-btn-arrow" />
            </div>
          </div>
        </div>
      </div>
      
      <div class="online-doctor-module">
        <!-- 标题区域 -->
        <div class="doctor-module-header">
          <div class="doctor-module-title">
        <span class="titspan">健康服务</span>
      </div>
      </div>
      <!-- 健康服务卡片网格 -->
      <div class="health-services-grid" >
       
        
        <!-- 门诊协助 -->
        <div class="health-service-card service-card-outpatient" @click="goToOutpatientAssist();flag(1)">
          <div class="service-card-content">
            <div class="service-card-text">
              <div class="service-card-title">门诊协助</div>
              <div class="service-card-desc">快速精准预约 三甲医院科室</div>
          </div>
          </div>        
        </div>        
     
        <!-- 购药商城 -->
        <div class="health-service-card service-card-pharmacy" @click="jd();flag(1)">
          <div class="service-card-content">
            <div class="service-card-text">
              <div class="service-card-title">购药商城</div>
              <div class="service-card-desc">在线商城,放心便捷购药</div>
          </div>
        </div>
            </div>

        <!-- 健康查一查 -->
        <div class="health-service-card service-card-checkup" @click="screen();flag(1)">
          <div class="service-card-content">
            <div class="service-card-text">
              <div class="service-card-title">健康查一查</div>
              <div class="service-card-desc">常见疾病查一查,了解病因与治疗方法</div>
          </div>
        </div>
            </div>

        <!-- 健康咨询 -->
        <div class="health-service-card service-card-consultation" @click="handleHealthConsultationClick();flag(1)">
          <div class="service-card-content">
            <div class="service-card-text">
              <div class="service-card-title">健康咨询</div>
              <div class="service-card-desc">日常健康小问题</div>
          </div>
        </div>
            </div>
         <!-- AI体检报告解读 -->
         <div class="health-service-card ai-report-card" @click="actionMedicalReport();flag(1)">
          <div class="ai-report-content">
            <div class="ai-report-text">
              <div class="ai-report-title">AI体检报告解读</div>
              <div class="ai-report-desc">智能分析深度分析,清楚知晓体验结果</div>
              <div class="ai-report-btn-wrapper">
                <img src="@/assets/serviceImg/service/Rectangle_346241914@2x.png" alt="按钮背景" class="ai-report-btn-bg" />
                <div class="ai-report-btn-text">去设置 <img src="@/assets/serviceImg/service/Frame@2x(4).png" alt="箭头" class="ai-report-btn-arrow" /></div>

          </div>
        </div>
          </div>
          </div>
        
        <!-- 安心家庭 -->
        <div class="health-service-card safe-family-card" @click="sharing();flag(1)">
          <div class="safe-family-content">
            <div class="safe-family-text">
              <div class="safe-family-title">安心家庭</div>
              <div class="safe-family-desc">绑定紧急联系人突发状况及时提醒通知</div>
              <div class="safe-family-btn-wrapper">
                <img src="@/assets/serviceImg/service/Rectangle_346241936@2x.png" alt="按钮背景" class="safe-family-btn-bg" />
                <div class="safe-family-btn-text">去设置 <img src="@/assets/serviceImg/service/Frame@2x(4).png" alt="箭头" class="safe-family-btn-arrow" /></div>

            </div>
          </div>
        </div>
      </div>
      </div>
      
      </div>
      
      <div class="online-doctor-module">
          <!-- 标题区域 -->
          <div class="doctor-module-header">
            <div class="doctor-module-title">
              <span class="titspan">出行救援服务</span>
            </div>
            </div>
          <!-- 出行救援服务网格 -->
          <div class="rescue-services-grid">
          <!-- 紧急医疗转运 -->
          <div class="rescue-service-item" @click="urgent();flag(2)">
            <div class="rescue-service-icon">
              <img src="@/assets/serviceImg/service/Frame_4108@2x.png" alt="紧急医疗转运" />
          </div>
            <div class="rescue-service-label">紧急医疗转运</div>
        </div>
        
          <!-- 医疗送返 -->
          <div class="rescue-service-item" @click="medicalReturn();flag(2)">
            <div class="rescue-service-icon">
              <img src="@/assets/serviceImg/service/Frame_4110@2x.png" alt="医疗送返" />
              </div>
            <div class="rescue-service-label">医疗送返</div>
              </div>
          
          <!-- 住院医疗监护 -->
          <div class="rescue-service-item" v-if="!showPrivateDoctorCard" @click="medicalGuardianship();flag(2)">
            <div class="rescue-service-icon">
              <img src="@/assets/serviceImg/service/Frame_4109@2x.png" alt="住院医疗监护" />
            </div>
            <div class="rescue-service-label">住院医疗监护</div>
          </div>
          
          <!-- 安全管家服务 -->
          <div class="rescue-service-item" v-if="!showPrivateDoctorCard" @click="butlerservice();flag(2)">
            <div class="rescue-service-icon">
              <img src="@/assets/serviceImg/service/Frame_4159@2x.png" alt="安全管家服务" />
              </div>
            <div class="rescue-service-label">安全管家服务</div>
              </div>
          
          <!-- 门诊协助 -->
          <div class="rescue-service-item" @click="goToOutpatientAssist()">
            <div class="rescue-service-icon">
              <img src="@/assets/serviceImg/service/Frame_4108@2x(1).png" alt="门诊协助" />
            </div>
            <div class="rescue-service-label">门诊协助</div>
          </div>
          
          <!-- 住院协作 -->
          <div class="rescue-service-item"  v-if="showPrivateDoctorCard"  @click="goToInpatientCollaboration()">
            <div class="rescue-service-icon">
              <img src="@/assets/serviceImg/service/Frame_4121@2x.png" alt="住院协作" />
        </div>
            <div class="rescue-service-label">住院协作</div>
      </div>
      
          <!-- 检查加急 -->
          <div class="rescue-service-item"  v-if="showPrivateDoctorCard"  @click="goToExpeditedExamination()">
            <div class="rescue-service-icon">
              <img src="@/assets/serviceImg/service/Frame_4108@2x(2).png" alt="检查加急" />
          </div>
            <div class="rescue-service-label">检查加急</div>
          </div>
          
          <!-- 入院陪护 -->
          <div class="rescue-service-item"  v-if="showPrivateDoctorCard"  @click="goToAdmissionEscort()">
            <div class="rescue-service-icon">
              <img src="@/assets/serviceImg/service/Frame_4108@2x(3).png" alt="入院陪护" />
          </div>
            <div class="rescue-service-label">入院陪护</div>
      </div>
      
          <!-- 二次诊疗 -->
          <div class="rescue-service-item"  v-if="showPrivateDoctorCard"  @click="goToSecondOpinion()">
            <div class="rescue-service-icon">
              <img src="@/assets/serviceImg/service/Frame_4108@2x(4).png" alt="二次诊疗" />
      </div>
            <div class="rescue-service-label">二次诊疗</div>
          </div>
                
          <!-- 多学科会诊 -->
          <div class="rescue-service-item"  v-if="showPrivateDoctorCard"  @click="goToMultidisciplinaryConsultation()">
            <div class="rescue-service-icon">
              <img src="@/assets/serviceImg/service/Frame_4108@2x(5).png" alt="多学科会诊" />
          </div>
            <div class="rescue-service-label">多学科会诊</div>
        </div>       
          
          <!-- 海外就医安排 -->
          <div class="rescue-service-item"  v-if="showPrivateDoctorCard"  @click="goToOverseasMedicalArrangement()">
            <div class="rescue-service-icon">
              <img src="@/assets/serviceImg/service/Frame_4108@2x(6).png" alt="海外就医安排" />
          </div>
            <div class="rescue-service-label">海外就医安排</div>
        </div>
          
          <!-- 全球找药 -->
          <div class="rescue-service-item"  v-if="showPrivateDoctorCard"  @click="goToGlobalMedicineSearch()">
            <div class="rescue-service-icon">
              <img src="@/assets/serviceImg/service/Frame 4108@2x(4).png" alt="全球找药" />
          </div>
            <div class="rescue-service-label">全球找药</div>
        </div>
          
          <!-- 院后康护指导 -->
          <div class="rescue-service-item"  v-if="showPrivateDoctorCard"  @click="goToPostDischargeCareGuidance()">
            <div class="rescue-service-icon">
              <img src="@/assets/serviceImg/service/Frame 4108@2x(5).png" alt="院后康护指导" />
          </div>
            <div class="rescue-service-label">院后康护指导</div>
        </div>
        
          <!-- 医后随访 -->
          <div class="rescue-service-item"  v-if="showPrivateDoctorCard"  @click="goToPostMedicalFollowUp()">
            <div class="rescue-service-icon">
              <img src="@/assets/serviceImg/service/Frame 4108@2x(6).png" alt="医后随访" />
          </div>
            <div class="rescue-service-label">医后随访</div>
            </div>
           
          <!-- 门诊协作 -->
          <!-- <div class="rescue-service-item" @click="handleRescueService('outpatientCollaboration')">
            <div class="rescue-service-icon">
              <img src="@/assets/serviceImg/service/Frame_4109@2x.png" alt="门诊协作" />
          </div>
            <div class="rescue-service-label">门诊协作</div>
          </div> -->
        </div>
      </div>
      </div>
     
      <div v-if="showModal" class="modal">
        <div class="modal-content">
          <span class="close" @click="showModal = false">&times;</span>
          <p style="margin-bottom: 7vw;">该项权益需开通以下服务权益</p>
          <div style="width:100%;height:40vw;position: relative;" @click="equity()">
            <img style="width: 100%;height: 100%;position: absolute;top: 2vw;" src="@/assets/img/qykbj.png" />
            <div>
              <h3 style="position: absolute;top: 17vw;left: 7vw;font-size: 5vw;">大救星-星健康权益卡</h3>
              <div style="position: absolute;top: 25vw;left: 7vw;color:#666666;font-size: 3.5vw;">多项健康权益尊享，为您健康守护</div>
              <div style="width: 18vw;height: 7vw;font-size: 3vw;line-height: 7vw;color: #F2D57A;text-align: center;background: rgb(74, 71, 64);border-radius: 16px;position: absolute;top: 17vw;right: 4vw;">了解更多</div>
            </div>
          </div>
        </div>
      </div>
      <Tabbar />
    
    <!-- 权益提示弹框 -->
    <van-dialog 
      v-model="showRightsDialog" 
      title="友情提示" 
      confirm-button-text="我知道了"
      confirm-button-color="#00C275"
      :show-cancel-button="false"
    >
      <div style="padding: 20px; text-align: center; font-size: 16px; line-height: 1.5;">
        您当前暂无权益，无法使用该功能
      </div>
    </van-dialog>

    <!-- 私人医生专属群弹框 -->
    <van-dialog 
      v-model="showPrivateDoctorDialog" 
      title="加入私人医生专属群"
      :show-cancel-button="false"
      :show-confirm-button="false"
      class="private-doctor-dialog"
    >
      <span class="private-doctor-close" @click="showPrivateDoctorDialog = false">×</span>
      <div class="private-doctor-content">
        <div class="qr-code-container">
          <img src="https://health.dajiuxing.com.cn/health/api/upload/3ac7e563-c415-4922-a266-aa450cd49f16.jpg" alt="私人医生群二维码" class="qr-code" />
        </div>
        <div class="instruction-text">
          为了更快捷服务于您，可以通过微信扫码进入私人医生服务群，专业医师日常解答
        </div>
        <div class="action-buttons">
          <van-button 
            type="primary" 
            class="action-btn save-btn"
            @click="saveQRCode"
          >
            保存二维码
          </van-button>
          <van-button 
            type="primary" 
            class="action-btn share-btn"
            @click="shareToWeChat"
            v-if="!($env && $env.inMiniProgram)"
          >
            分享到微信
          </van-button>
        </div>
      </div>
    </van-dialog>
  </div>

</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useGlobalStore } from '@/stores/global';
import { useUserStore } from '@/stores/user';
import { skipstore,appnews,equityinfo,flag,binddeviceinfo,getJumpUrl,getWechatMiniProgramJumpParam,recordUserAccess } from '@/api/activity'

export default {
  components: {
    Tabbar: () => import("@/components/Tabbar")
  },
  data() {
    return {
      currentPosition: 0,
      list:[],
      showModal: false,
      equityinfoType:false,
      hasRights: true, // 是否有权益
      showRightsDialog: false, // 显示权益提示弹框
      showPrivateDoctorDialog: false, // 显示私人医生专属群弹框
      showPrivateDoctorCard: true, // 是否显示私人医生一对一解答卡片，默认显示
      equityDetailLoading: true, // equity/v2/detail 是否加载完成
      productId: null, // 权益详情 productId，出行救援服务跳转时传递
    };
  },
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight']),
    /**
     * 状态栏高度（小程序固定 10px，其他环境沿用全局）
     * @returns {number}
     */
    effectiveStatusBarHeight() {
      if (this.$env && this.$env.inMiniProgram) return 10;
      return Number(this.statusBarHeight) || 0;
    }
	},
  async mounted() {
    this.init();
    this.appnews();
    this.checkDeviceRights();
    try {
      // 等待 equity/v2/detail（queryHealthQuanyi）调用完成再展示页面
      await this.checkPrivateDoctorCard();
    } finally {
      this.equityDetailLoading = false;
    }
    window.addEventListener('scroll', this.updateCurrentPosition);
  },

  beforeCreate() {
    window.removeEventListener('scroll', this.updateCurrentPosition);
    document.title = "服务"
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#F2F3F5");
  },
  methods: {
    /**
     * 打开客服页面
     * 使用统一的在线客服链接，Android 和 iOS 都适用
     */
    openCustomerService() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      console.log('打开客服页面');
      
      // 统一的客服链接（Android 和 iOS 都使用此链接）
      const customerServiceUrl = 'https://webchat-bj.tinetcloud.com/chat.html?accessId=50c33896-5172-49a9-a2eb-9c0a25b6c5a2&language=zh_CN';
      
      try {
        console.log('客服链接:', customerServiceUrl);
        
        // 跳转到客服页面
        window.location.href = customerServiceUrl;
        this.$message.success('正在打开客服...');
        
      } catch (error) {
        console.error('打开客服失败:', error);
        this.$message.error('打开客服失败，请重试');
      }
    },
    
    /**
     * 判断当前环境
     * @returns {boolean} true为测试环境，false为正式环境
     */
    isTestEnvironment() {
      return window.SEVSRS && window.SEVSRS.includes('thealth.dajiuxing.com.cn');
    },

    /**
     * 判断是否为本地环境（localhost / 127.0.0.1 / 局域网 IP）
     * @returns {boolean}
     */
    isLocalEnvironment() {
      try {
        const host = String(window.location && window.location.hostname ? window.location.hostname : '');
        if (!host) return false;
        if (host === 'localhost' || host === '127.0.0.1') return true;
        // 简单识别常见局域网段
        if (/^(10|192)\./.test(host)) return true;
        if (/^172\.(1[6-9]|2\d|3[0-1])\./.test(host)) return true;
        return false;
      } catch (e) {
        return false;
      }
    },
    
    /**
     * 生成基于环境的H5 URL
     * @param {string} path - 路径，如 '/equity'
     * @param {Object} [options] - 可选配置
     * @param {boolean} [options.forceHttps] - 为 true 时公网测试/正式域名使用 https（小程序 web-view 要求）
     * @returns {string} 完整的URL
     */
    getH5Url(path, options = {}) {
      const forceHttps = !!(options && options.forceHttps);
      // 本地环境：同域跳转，避免跳到正式/测试环境
      if (this.isLocalEnvironment()) {
        const origin = (window.location && window.location.origin) ? window.location.origin : '';
        return origin + '/h5/#' + path;
      }
      console.log(this.isTestEnvironment())
      // 非本地环境：保持现有测试/正式逻辑（小程序等场景可强制 https）
      let baseUrl = this.isTestEnvironment()
        ? 'http://thealth.dajiuxing.com.cn/h5/#'
        : 'http://health.dajiuxing.com.cn/h5/#';
      if (forceHttps) {
        baseUrl = baseUrl.replace(/^http:\/\//i, 'https://');
      }
      return baseUrl + path;
    },
    
    /**
     * 生成跳转链接
     * - 小程序环境：返回标准 H5 地址（不能使用 appdjxhealth:// scheme）
     * - App 内嵌 H5 / 浏览器：返回 App 跳转 scheme，保持原逻辑
     * @param {string} path - 路径，如 '/equity'
     * @returns {string} 跳转链接
     */
    getAppJumpUrl(path) {
      // 判断是否为微信小程序环境：以 wx.miniProgram 是否可用为准
      const isMiniProgram = typeof wx !== 'undefined' && wx.miniProgram && typeof wx.miniProgram.navigateTo === 'function';
      const h5Url = this.getH5Url(path, { forceHttps: isMiniProgram });
      if (isMiniProgram) {
        // 小程序 webview 中只能使用 https H5 地址（getH5Url 已 forceHttps）
        return h5Url;
      }
      // App 内嵌 H5 / 普通浏览器中，仍然使用原有 App 协议跳转
      return 'appdjxhealth://actionOpenh5?url=' + encodeURIComponent(h5Url);
    },
    /**
     * 出行救援服务跳转链接（带 productId 查询参数）
     * - 小程序环境：返回纯 H5 路径，交由小程序 webview 打开
     * - App 内嵌 H5 / 浏览器：保持原有 App 跳转 scheme，不改现有逻辑
     * @param {string} path - 路径，如 '/urgent'
     * @returns {string} 跳转链接
     */
    getRescueJumpUrl(path) {
      const query = this.productId != null ? '?productId=' + encodeURIComponent(this.productId) : '';
      const fullPath = path + query;
      // 判断是否为微信小程序环境：以 wx.miniProgram 是否可用为准
      const isMiniProgram = typeof wx !== 'undefined' && wx.miniProgram && typeof wx.miniProgram.navigateTo === 'function';
      if (isMiniProgram) {
        // 小程序环境中不能使用 appdjxhealth:// scheme，返回 https H5 地址
        return this.getH5Url(fullPath, { forceHttps: true });
      }
      // App 内嵌 H5 / 普通浏览器：保持原有 App 跳转方式
      return this.getAppJumpUrl(fullPath);
    },

    /**
     * 跳转到权益页面
     */
    // equity() {
    //   this.$router.push({
    //           path: "/healthHomePage",
    //           query:{
    //           }
    //         });
    // },
    async init() {
      let data = {}
      let res = await equityinfo(data)
      if (res.code == '1000') {
        this.equityinfoType = res.data.isHave
        localStorage.setItem('equityinfo', res.data.isHave);
      }
    },
    async appnews() {
      let data = {}
      let res = await appnews(data)
      if (res.code == '1000') {
        this.list = res.data
      }
    },
    async flag(item) {
      let res = await flag(item)
      if (res.code == '1000') {
      }
    },
    /**
     * 检查设备权益
     */
    async checkDeviceRights() {
      try {
        const res = await binddeviceinfo();
        if (res.code === '1000') {
          // 检查是否有 data
          this.hasRights = !!(res.data && Object.keys(res.data).length > 0);
        } else {
          this.hasRights = false;
        }
      } catch (error) {
        console.error('检查设备权益失败:', error);
        this.hasRights = false;
      }
    },
    /**
     * 检查是否显示私人医生一对一解答卡片
     * 如果 productId 是 843，则隐藏卡片
     */
    async checkPrivateDoctorCard() {
      try {
        const res = await this.queryHealthQuanyi();
        if (res && res.data && res.data.length > 0) {
          const productId = res.data[0].productId;
          this.productId = productId;
          // 如果 productId 是 843，隐藏卡片
          console.log('productId', productId);
          this.showPrivateDoctorCard = productId != 947;
        } else {
          // 如果没有数据，默认显示卡片
          this.showPrivateDoctorCard = true;
          this.productId = null;
        }
      } catch (error) {
        console.error('检查权益详情失败:', error);
        // 出错时默认显示卡片
        this.showPrivateDoctorCard = true;
        this.productId = null;
      }
    },
    /**
     * 检查权益并处理点击事件
     */
    checkRightsAndHandle(callback) {
      console.log('checkRightsAndHandle', this.hasRights);
      if (!this.hasRights) {
        this.showRightsDialog = true;
        return;
      }
      if (callback && typeof callback === 'function') {
        callback();
      }
    },
    /**
     * 处理图文医生点击（带记录）
     */
    handleGraphicDoctorClick() {
      this.recordUserClick('GRAPHIC_DOCTOR');
      this.checkRightsAndHandle(() => this.actionOnlineAiDoctor(3));
    },
    /**
     * 处理视频医生点击（带记录）
     */
    handleVideoDoctorClick() {
      this.recordUserClick('VIDEO_DOCTOR');
      this.checkRightsAndHandle(() => this.actionOnlineAiDoctor(1));
    },
    /**
     * 处理电话医生点击（带记录）
     */
    handlePhoneDoctorClick() {
      this.recordUserClick('PHONE_DOCTOR');
      this.checkRightsAndHandle(() => this.actionOnlineAiDoctor(2));
    },
    /**
     * 处理健康咨询点击（带记录）
     */
    handleHealthConsultationClick() {
      console.log('handleHealthConsultationClick', this.equityinfoType);
      if(this.equityinfoType == false) {
        this.showModal = true;
      }else {
        // 仅在微信小程序 web-view 环境提示；其他环境走原生 scheme
        if (this.$env && this.$env.inMiniProgram) {
          if (this.$toast) {
            this.$toast('请去APP中使用该功能');
          } else if (window && window.alert) {
            window.alert('请去APP中使用该功能');
          }
          return;
        }
        window.location.href = 'appdjxhealth://actionOnlineAiDoctor'
      }
    },
    urlClick(item) {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      window.location.href =
        'appdjxhealth://actionOpenh5?url='   + encodeURIComponent(item.url)
    },
    /**
     * 格式化日期为 yyyy-MM-dd 格式
     * @returns {string} 格式化后的日期字符串
     */
    formatAccessTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    /**
     * 记录用户点击
     * @param {string} moduleName - 模块编码
     */
    recordUserClick(moduleName) {
      // 立即调用，不阻塞主流程
      const accessTime = this.formatAccessTime();
      console.log('开始记录用户点击:', moduleName, '访问时间:', accessTime);
      recordUserAccess({
        moduleName: moduleName,
        accessTime: accessTime
      }).then(res => {
        console.log('记录用户点击成功:', moduleName, res);
      }).catch(error => {
        // 记录失败不影响主流程，只打印日志
        console.error('记录用户点击失败:', moduleName, error);
      });
    },
    /**
     * 获取跳转链接并跳转
     * @param {number} type - 类型：1-视频医生，2-电话医生，3-图文医生，undefined-健康咨询
     */
    async actionOnlineAiDoctor(type) {
      console.log('actionOnlineAiDoctor', this.equityinfoType);
      if(this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      
      try {
        const res = await getJumpUrl({ type });
        if ((res.code === '2000' || res.code === 2000) && res.data) {
          window.location.href = res.data;
        } else {
          console.error('获取跳转链接失败:', res);
          // 如果接口失败，显示权益提示弹框
          this.showModal = true;
        }
      } catch (error) {
        console.error('调用在线医生接口失败:', error);
        // 如果接口失败，显示权益提示弹框
        this.showModal = true;
      }
    },
    actionMedicalReport() {
      this.checkRightsAndHandle(() => {
        if(this.equityinfoType == false) {
          this.showModal = true;
        }else {
          // 仅在微信小程序 web-view 环境提示；其他环境走原生 scheme
          if (this.$env && this.$env.inMiniProgram) {
            if (this.$toast) {
              this.$toast('请去APP中使用该功能');
            } else if (window && window.alert) {
              window.alert('请去APP中使用该功能');
            }
            return;
          }
          window.location.href = 'appdjxhealth://actionMedicalReport'
        }
      });
    },
    /**
     * 一键救援
     */
    actionCallHelp() {
      this.$router.push({
        name: 'onClickRescue',
        query: {}
     });
      // this.checkRightsAndHandle(async () => {
      //   try {
      //     const res = await this.queryHealthQuanyi();
      //     const userName = res && res.data && res.data[0] ? res.data[0].userName : '';

      //     if (userName === '绿豆芽3') {
      //       this.$router.push({ name: 'onClickRescue', query: {} });
      //       return;
      //     }
      //   } catch (e) {
      //     // 权益接口失败不影响原有救援能力，直接走原有方式
      //     console.warn('equity/v2/detail 获取失败，继续使用原有救援方式:', e);
      //   }

      //   window.location.href = 'appdjxhealth://actionCallHelp';
      // });
    },
    /**
     * 按《微信小程序跳转互联网医院说明》拼接目标小程序 path：`id`、`channel`（RSA 密文由后端给出）、`redirect`（默认 shop）
     * 注意：部分后端可能已对 channel 做过一次 URL 编码（含 %2B/%2F/%3D），前端若再次 encode 会导致对方解码/验签失败，从而报“渠道号异常”
     * @param {string} basePath - 不以 `/` 开头，如 `pages/login/login`
     * @param {{ id: string, channel: string, redirect?: string }} q - 查询参数
     * @returns {string}
     */
    encodeMiniProgramQueryValue(v) {
      const s = String(v == null ? '' : v).trim();
      if (!s) return '';
      // 若已是 percent-encoded（解码再编码可回到原值），则认为后端已编码，避免二次编码
      if (s.includes('%')) {
        try {
          const decoded = decodeURIComponent(s);
          const reencoded = encodeURIComponent(decoded);
          if (reencoded === s) {
            return s;
          }
        } catch (e) {
          // ignore
        }
      }
      return encodeURIComponent(s);
    },
    buildInternetHospitalMiniPath(basePath, q) {
      // 按需求：path 仅保留页面路径，不携带 query；参数统一走 extraData
      const b = String(basePath || 'pages/login/login').replace(/^\//, '');
      return b.split('?')[0];
    },
    /**
     * 解析 `get-wechat-mini-program-jump-param` 的 data，对齐《微信小程序跳转互联网医院说明》与微信官方
     * wx.navigateToMiniProgram（https://developers.weixin.qq.com/miniprogram/dev/api/navigate/wx.navigateToMiniProgram.html）
     * —— 仅产出宿主小程序桥接页所需的 `appId`、`envVersion`、完整 `path`（path 上携带 id、channel、redirect）。
     * @param {*} raw - 接口 data 原值
     * @returns {{ kind: 'http', url: string }|{ kind: 'external', appId: string, path: string, envVersion: 'trial'|'release', extraData: Record<string, unknown> }|null}
     */
    normalizePharmacyMpJumpData(raw) {
      let v = raw;
      if (typeof v === 'string') {
        const t = v.trim();
        if (!t) {
          return null;
        }
        if (/^https?:\/\//i.test(t)) {
          return { kind: 'http', url: t };
        }
        try {
          v = JSON.parse(t);
        } catch (e) {
          return null;
        }
      }
      if (!v || typeof v !== 'object') {
        return null;
      }
      const jumpUrl = String(v.jumpUrl || v.h5Url || v.linkUrl || '').trim();
      if (jumpUrl && /^https?:\/\//i.test(jumpUrl)) {
        return { kind: 'http', url: jumpUrl };
      }
      const appId = String(
        v.appId || v.miniProgramAppId || (v.miniProgram && v.miniProgram.appId) || ''
      ).trim();
      if (!appId) {
        return null;
      }
      const envRaw = String(
        v.envVersion || (v.miniProgram && v.miniProgram.envVersion) || 'release'
      ).trim();
      const envVersion = envRaw === 'trial' || envRaw === 'release' ? envRaw : 'release';
      const extraDataFromApi =
        v.extraData && typeof v.extraData === 'object' && !Array.isArray(v.extraData) ? v.extraData : {};
      const pathRaw = String(
        v.path || v.pagePath || (v.miniProgram && v.miniProgram.path) || ''
      ).trim();
      const pathNoLead = pathRaw.replace(/^\//, '');
      const idVal =
        v.id !== undefined && v.id !== null
          ? v.id
          : v.userId !== undefined && v.userId !== null
            ? v.userId
            : v.user_id !== undefined && v.user_id !== null
              ? v.user_id
              : '';
      const channelVal =
        v.channel !== undefined && v.channel !== null
          ? v.channel
          : v.encryptedChannel !== undefined && v.encryptedChannel !== null
            ? v.encryptedChannel
            : '';
      const redirectVal =
        v.redirect !== undefined && v.redirect !== null ? String(v.redirect) : 'shop';
      // 兜底：若接口未提供 extraData，则把 id/channel/redirect 也补到 extraData（目标小程序可从 referrerInfo.extraData 取）
      const extraData = Object.assign({}, extraDataFromApi);
      // 当接口返回了分项字段时，优先用分项字段；否则尝试从 path 查询串解析
      let finalId = idVal;
      let finalChannel = channelVal;
      let finalRedirect = redirectVal;
      if ((finalId === '' || finalChannel === '') && pathNoLead && pathNoLead.indexOf('?') >= 0) {
        try {
          const q = pathNoLead.split('?')[1] || '';
          const params = new URLSearchParams(q);
          if (finalId === '' && params.get('id')) finalId = params.get('id');
          if (finalChannel === '' && params.get('channel')) finalChannel = params.get('channel');
          if (params.get('redirect')) finalRedirect = params.get('redirect');
        } catch (e) {
          // ignore
        }
      }
      if (finalId !== '' && typeof extraData.id === 'undefined') extraData.id = String(finalId);
      if (finalChannel !== '' && typeof extraData.channel === 'undefined') extraData.channel = String(finalChannel);
      if (finalRedirect !== '' && typeof extraData.redirect === 'undefined') extraData.redirect = String(finalRedirect);
      /** 接口已返回完整 path（含查询串）：按需求去掉 query，仅保留页面路径；参数走 extraData */
      if (pathNoLead && pathNoLead.indexOf('?') >= 0) {
        const basePath = pathNoLead.split('?')[0];
        return { kind: 'external', appId, path: basePath, envVersion, extraData };
      }
      /** 分项返回：按说明拼 path */
      if (idVal !== '' && channelVal !== '') {
        const baseOnly = pathNoLead ? pathNoLead.split('?')[0] : 'pages/login/login';
        const path = this.buildInternetHospitalMiniPath(baseOnly, {
          id: idVal,
          channel: channelVal,
          redirect: redirectVal
        });
        return { kind: 'external', appId, path, envVersion, extraData };
      }
      return null;
    },
    /**
     * 获取跳转链接并跳转 - 购药商城
     * - 微信小程序 web-view（且非大救星 App 内嵌）：调 `getWechatMiniProgramJumpParam`，按《微信小程序跳转互联网医院说明》经桥接页调 `wx.navigateToMiniProgram`；**App 内嵌 H5**（`inDjxApp`）不进入本分支，仍走 `getJumpUrl`
     * - 其他环境：`getJumpUrl` + 跳转
     */
    async jd() {
      // 记录用户点击
      this.recordUserClick('PHARMACY_MALL');
      // 临时关闭权益校验，便于联调/点击购药商城（联调完成后可恢复 hasRights 判断）
      if (!this.hasRights) {
        this.showRightsDialog = true;
        return;
      }

      /**
       * 与 App 内嵌 H5 区分：`inDjxApp` 为 true 时不走小程序专用逻辑（见 `@/assets/js/env.js`）
       */
      if (this.$env && this.$env.inMiniProgram && !(this.$env && this.$env.inDjxApp)) {
        const wxMini =
          typeof wx !== 'undefined' &&
          wx.miniProgram &&
          typeof wx.miniProgram.navigateTo === 'function';
        try {
          const res = await getWechatMiniProgramJumpParam();
          console.log('[购药商城][小程序web-view] get-wechat-mini-program-jump-param 完整返回:', res);
          const ok =
            res &&
            (res.code === '1000' ||
              res.code === 1000 ||
              res.code === '2000' ||
              res.code === 2000);
          if (!ok) {
            console.warn('[购药商城][小程序web-view] 接口非成功状态:', res);
            if (this.$toast) {
              this.$toast((res && res.msg) || '获取购药跳转参数失败');
            }
            return;
          }
          const parsed = this.normalizePharmacyMpJumpData(res.data);
          if (parsed && parsed.kind === 'http') {
            window.location.href = parsed.url;
            return;
          }
          /** 互联网医院：仅走桥接页 + wx.navigateToMiniProgram（与心电等其它跳转逻辑隔离） */
          if (parsed && parsed.kind === 'external' && wxMini) {
            const { appId, path, envVersion, extraData } = parsed;
            const extraStr =
              extraData && typeof extraData === 'object' ? JSON.stringify(extraData) : '';
            let bridgeUrl =
              `/pages/bridge/index?action=openPharmacy&appId=${encodeURIComponent(appId)}` +
              `&path=${encodeURIComponent(path)}&envVersion=${encodeURIComponent(envVersion)}`;
            // extraData 通过桥接页透传给 navigateToMiniProgram（参考项目内其他跳转小程序的用法）
            if (extraStr && extraStr !== '{}' && extraStr.length <= 600) {
              bridgeUrl += `&extraData=${encodeURIComponent(extraStr)}`;
            }
            if (bridgeUrl.length > 2040) {
              console.warn('[购药商城][小程序] bridge URL 过长，已省略 extraData（必要时请缩短 channel 或改为后端短参）');
              bridgeUrl =
                `/pages/bridge/index?action=openPharmacy&appId=${encodeURIComponent(appId)}` +
                `&path=${encodeURIComponent(path)}&envVersion=${encodeURIComponent(envVersion)}`;
            }
            wx.miniProgram.navigateTo({ url: bridgeUrl });
            return;
          }
          console.warn('[购药商城][小程序web-view] 无法解析跳转参数 data:', res.data);
          if (this.$toast) {
            this.$toast('购药跳转参数异常，请稍后重试');
          }
        } catch (error) {
          console.error('[购药商城][小程序web-view] get-wechat-mini-program-jump-param 请求异常:', error);
          if (this.$toast) {
            this.$toast('获取购药跳转参数失败');
          }
        }
        return;
      }
      
      try {
        const res = await getJumpUrl({ type: 45 });
        const url = res && typeof res.data === 'string' ? res.data.trim() : '';
        if ((res.code === '2000' || res.code === 2000) && url) {
          window.location.href = url;
        } else {
          console.error('获取购药商城跳转链接失败:', res);
          // 接口失败或链接为空：提示开通权益弹框
          this.showModal = true;
        //  skipstore().then((res)=> {
        //    window.location.href = 'appdjxhealth://actionOpenh5?url=' + encodeURIComponent(res.data);
        //  });
        }
      } catch (error) {
        console.error('调用购药商城接口失败:', error);
        // 接口失败：提示开通权益弹框
        this.showModal = true;
        //skipstore().then((res)=> {
         // window.location.href = 'appdjxhealth://actionOpenh5?url=' + encodeURIComponent(res.data);
        //});
      }
    },
    equity() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getAppJumpUrl('/taiheHealthMonitoring');
      });
    },
    sharing() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
      this.$router.push({
              name: "sharing",
              params:{
                ecgContent:this.ecgContent
              }
            });
          });
      // this.checkRightsAndHandle(() => {
      //   window.location.href = this.getAppJumpUrl('/sharing');
      // });
    },
    assist() {
      // 记录用户点击
      this.recordUserClick('OUTPATIENT_COLLABORATION');
      
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getAppJumpUrl('/assist');
      });
    },
    urgent() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getRescueJumpUrl('/urgent');
      });
    },
    toilet() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getAppJumpUrl('/toilet');
      });
    },
    unlocking() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getAppJumpUrl('/unlocking');
      });
    },
    service1() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getAppJumpUrl('/service1');
      });
    },
    butlerservice() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getRescueJumpUrl('/butlerservice');
      });
    },
    medicalReturn() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getRescueJumpUrl('/medicalReturn');
      });
    },
    medicalGuardianship() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getRescueJumpUrl('/medicalGuardianship');
      });
    },
    /**
     * 跳转到门诊协助页面
     */
    goToOutpatientAssist() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      // 记录用户点击
      this.recordUserClick('OUTPATIENT_COLLABORATION');
      
      this.checkRightsAndHandle(() => {
        window.location.href = this.getRescueJumpUrl('/outpatientAssist');
      });
    },
    /**
     * 跳转到住院协作页面
     */
    goToInpatientCollaboration() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getRescueJumpUrl('/inpatientCollaboration');
      });
    },
    /**
     * 跳转到检查加急页面
     */
    goToExpeditedExamination() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getRescueJumpUrl('/expeditedExamination');
      });
    },
    /**
     * 跳转到入院陪护页面
     */
    goToAdmissionEscort() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getRescueJumpUrl('/admissionEscort');
      });
    },
    /**
     * 跳转到二次诊疗页面
     */
    goToSecondOpinion() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getRescueJumpUrl('/secondOpinion');
      });
    },
    /**
     * 跳转到多学科会诊页面
     */
    goToMultidisciplinaryConsultation() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getRescueJumpUrl('/multidisciplinaryConsultation');
      });
    },
    /**
     * 跳转到海外就医安排页面
     */
    goToOverseasMedicalArrangement() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getRescueJumpUrl('/overseasMedicalArrangement');
      });
    },
    /**
     * 跳转到全球找药页面
     */
    goToGlobalMedicineSearch() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getRescueJumpUrl('/globalMedicineSearch');
      });
    },
    /**
     * 跳转到院后康护指导页面
     */
    goToPostDischargeCareGuidance() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getRescueJumpUrl('/postDischargeCareGuidance');
      });
    },
    /**
     * 跳转到医后随访页面
     */
    goToPostMedicalFollowUp() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getRescueJumpUrl('/postMedicalFollowUp');
      });
    },
  
    /**
     * 处理出行救援服务点击
     * @param {string} serviceType - 服务类型
     */
    handleRescueService(serviceType) {
      // 有二级页面的服务类型映射
      const serviceRoutes = {
        // 这里可以添加有二级页面的服务
      };
      
      if (serviceRoutes[serviceType]) {
        // 有二级页面，跳转
        if (this.equityinfoType == false) {
          this.showModal = true;
          return;
        }
        this.checkRightsAndHandle(() => {
          window.location.href = this.getRescueJumpUrl(serviceRoutes[serviceType]);
        });
      } else {
        // 没有二级页面，显示提示
        this.$message.info('暂无相关页面');
      }
    },
    doctor() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getAppJumpUrl('/doctor');
      });
    },
    admission() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      this.checkRightsAndHandle(() => {
        window.location.href = this.getAppJumpUrl('/admission');
      });
    },
    screen() {
      // 记录用户点击
      this.recordUserClick('HEALTH_CHECK');
      
      this.checkRightsAndHandle(() => {
        if(this.equityinfoType == false) {
          this.showModal = true;
        }else {
          window.location.href = this.getAppJumpUrl('/screen');
        }
      });
    },
    showPrivateDoctorGroup() {
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }
      if (!this.hasRights) {
        this.showRightsDialog = true;
        return;
      }
      this.showPrivateDoctorDialog = true;
    },
    /**
     * 保存私人医生群二维码
     * - 仅微信小程序 web-view：跳转小程序中转页保存到相册
     * - App 内嵌 H5：必须用 scheme（优先于 wx 误判，避免页面注入 wx 时走错分支）
     * - 其他环境：沿用 scheme
     */
    saveQRCode() {
      const qrCodeUrl = 'https://health.dajiuxing.com.cn/health/api/upload/3ac7e563-c415-4922-a266-aa450cd49f16.jpg';
      if (this.equityinfoType == false) {
        this.showModal = true;
        return;
      }

      const inApp = this.$env && this.$env.inDjxApp;
      const inMiniProgram = this.$env && this.$env.inMiniProgram;

      // 1) App 内嵌 H5（含微信外任意 WebView）：优先且仅走 scheme，不受 wx/小程序影响
      if (inApp) {
        window.location.href = 'appdjxhealth://actionSavePicture?picUrl=' + qrCodeUrl;
        this.showPrivateDoctorDialog = false;
        return;
      }

      // 2) 仅微信小程序 web-view：走小程序中转页保存
      if (inMiniProgram && typeof wx !== 'undefined' && wx.miniProgram && typeof wx.miniProgram.navigateTo === 'function') {
        try {
          const u = encodeURIComponent(qrCodeUrl);
          wx.miniProgram.navigateTo({ url: `/pages/qrAction/index?action=save&url=${u}` });
        } catch (e) {
          console.warn('miniProgram navigateTo save qr failed', e);
        }
        this.showPrivateDoctorDialog = false;
        return;
      }

      // 3) 其他环境：沿用 scheme（如系统浏览器尝试唤起 App）
      window.location.href = 'appdjxhealth://actionSavePicture?picUrl=' + qrCodeUrl;
      this.showPrivateDoctorDialog = false;
    },
    /**
     * 分享二维码到微信
     * - App 内嵌 H5（微信外/任意 WebView）：优先且仅走原生 JSInterface，不受 wx/小程序影响
     * - 仅微信小程序 web-view：跳转小程序中转页分享
     */
    shareToWeChat() {
      const qrCodeUrl = 'https://health.dajiuxing.com.cn/health/api/upload/3ac7e563-c415-4922-a266-aa450cd49f16.jpg';

      const inApp = this.$env && this.$env.inDjxApp;
      const inMiniProgram = this.$env && this.$env.inMiniProgram;

      // 1) App 内嵌 H5：保持原逻辑，最先判断并 return
      if (inApp) {
        if (this.$env.inAndroid) {
          try {
            JSInterface.shareWeChatWorkQR();
          } catch (error) {
            console.log(error);
          }
        } else if (this.$env.inIos) {
          try {
            // 此方法传递链接为使用传递的图片，不传递链接使用默认图片
            window.webkit.messageHandlers.shareWeChatWorkQR.postMessage(null);
          } catch (error) {
            console.log(error);
          }
        }
        this.showPrivateDoctorDialog = false;
        return;
      }

      // 2) 仅微信小程序 web-view
      if (inMiniProgram && typeof wx !== 'undefined' && wx.miniProgram && typeof wx.miniProgram.navigateTo === 'function') {
        try {
          const u = encodeURIComponent(qrCodeUrl);
          wx.miniProgram.navigateTo({ url: `/pages/qrAction/index?action=share&url=${u}` });
        } catch (e) {
          console.warn('miniProgram navigateTo share qr failed', e);
        }
        this.showPrivateDoctorDialog = false;
        return;
      }

      // 3) 其他环境（系统浏览器、微信内置浏览器非 web-view 等）：仅关闭弹框，与历史行为一致
      this.showPrivateDoctorDialog = false;
    },

    updateCurrentPosition() {
      this.currentPosition = window.scrollY;
    },
    ...mapActions(useUserStore, ['queryHealthQuanyi'])
  },
};
</script>
<style scoped>
.service-page-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.service-page-loading-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #e0e0e0;
  border-top-color: #00C275;
  border-radius: 50%;
  animation: serviceSpin 0.8s linear infinite;
  margin-bottom: 12px;
}

.service-page-loading-text {
  font-size: 14px;
  color: #666666;
}

@keyframes serviceSpin {
  to { transform: rotate(360deg); }
}

.text-wrapper_5 {
  box-shadow: inset 0px 0px 8px 1px rgba(255, 255, 255, 1), 0 4px 12px rgba(0, 194, 117, 0.3);
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.5);
  margin: 5px 0 0 287px;
  padding: 19px 17px 8px 17px;
  text-align: center;
  transition: all 0.3s ease;
}

.paragraph_3 {
  width: 28px;
  height: 46px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: justify;
  line-height: 3.5vh;
}
.section_2 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 16px;
  margin: 16px 2px 0 0;
  padding-left: 15%;
  /* padding: 25px 64px 24px 65px; */
}

.text-wrapper_4 {
  /* background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng3846fcaba491e0459340b60f4cdb52db5ea95eb7401b31e07ae44d5cd7855951) -9px -9px */
    /* no-repeat; */
    margin-top:10px;
    text-align: center;
  background-size: 232px 63px;
  padding: 8px 51px 12px 51px;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  box-shadow: 0 4px 12px rgba(0, 194, 117, 0.3);
    border-radius: 2.42667rem;
    width: 85%;
    transition: all 0.3s ease;
}

.text_18 {
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.23);
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  letter-spacing: 8px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: justify;
  white-space: nowrap;
  line-height: 30px;
}
.service-container {
  min-height: 100vh;
  background-color:#F2F3F5;
  padding-bottom: 180px; /* 为底部 Tabbar 留出间距 */
}
* {
  margin: 0 auto;
  padding: 0;
  font-family: "微软雅黑";
}
.prize1 {
  border-radius: 40px;padding: 5px 0vh;padding-left: 5px;display: flex;align-items: center;margin-top: 15px;
}
.prize1Img {
  width:25px;
}

/* 健康服务卡片网格 */
.health-services-grid {
  /* width: 90%; */
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  background: #ffffff;
  border-radius: 12px;
  /* padding: 15px; */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* AI体检报告和安心家庭卡片占据整行 */
.ai-report-card {
  grid-column: 1 / -1;
}

.safe-family-card {
  grid-column: 1 / -1;
}

.health-service-card {
  height: 480.77px;
  background: #ffffff;
  border-radius: 20px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  overflow: hidden;
}

.health-service-card:active {
  transform: scale(0.98);
  opacity: 0.9;
}

.health-service-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  min-height: 0;
}

.health-service-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.health-service-title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  margin: 0;
  line-height: 1.2;
}

.health-service-desc {
  font-size: 13px;
  color: #999999;
  margin: 0;
  line-height: 1.5;
}

.health-service-icon {
  width: 100%;
  height: 200px;
  background: transparent;
  flex-shrink: 0;
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.health-service-btn {
  align-self: flex-start;
  padding: 6px 14px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  margin-top: 12px;
}

.blue-btn-small {
  background: linear-gradient(135deg, #4A90E2 0%, #6BB3FF 100%);
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(74, 144, 226, 0.2);
}

.green-btn-small {
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 194, 117, 0.2);
}

.health-service-btn:active {
  transform: scale(0.95);
}

/* AI体检报告解读卡片样式 */
.ai-report-card {
  width: 100%;
  height: 92.17px;
  background: url('~@/assets/serviceImg/service/Frame_4261@2x.png') no-repeat center;
  background-size: 100% 100%;
  border-radius: 20px;
  padding: 0;
  margin: 0;
  position: relative;
  overflow: hidden;
}

.ai-report-content {
  width: 100%;
  height: 100%;
  padding-top: 16px;
  padding-left: 9px;
  padding-right: 9px;
  padding-bottom: 0;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
}

.ai-report-text {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
}

.ai-report-title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #333333;
  margin: 0;
  line-height: 1.2;
}

.ai-report-desc {
  font-size: 12px;
  color: #999999;
  margin: 0;
  line-height: 1.3;
  margin-top: 5px;
  margin-bottom: 5px;
}

.ai-report-btn-wrapper {
  position: relative;
  width: 57px;
  height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  margin: 0;
  gap: 0;
  align-self: flex-start;
}

.ai-report-btn-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ai-report-btn-text {
  position: relative;
  z-index: 1;
  font-size: 11px;
  color: #ffffff;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ai-report-btn-arrow {
  position: relative;
  z-index: 1;
  width: auto;
  height: 10px;
  object-fit: contain;
  flex-shrink: 0;
  margin: 0;
}

/* 安心家庭卡片样式 */
.safe-family-card {
  width: 100%;
  height: 92.17px;
  background: url('~@/assets/serviceImg/service/Frame_4260@2x.png') no-repeat center;
  background-size: 100% 100%;
  border-radius: 20px;
  padding: 0;
  margin: 0;
  position: relative;
  overflow: hidden;
}

.safe-family-content {
  width: 100%;
  height: 100%;
  padding-top: 16px;
  padding-left: 9px;
  padding-right: 9px;
  padding-bottom: 0;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
}

.safe-family-text {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
}

.safe-family-title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #333333;
  margin: 0;
  line-height: 1.2;
}

.safe-family-desc {
  font-size: 12px;
  color: #999999;
  margin: 0;
  line-height: 1.3;
  margin-top: 5px;
  margin-bottom: 5px;
}

.safe-family-btn-wrapper {
  position: relative;
  width: 57px;
  height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  margin: 0;
  gap: 0;
  align-self: flex-start;
}

.safe-family-btn-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.safe-family-btn-text {
  position: relative;
  z-index: 1;
  font-size: 11px;
  color: #ffffff;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.safe-family-btn-arrow {
  position: relative;
  z-index: 1;
  width: auto;
  height: 10px;
  object-fit: contain;
  flex-shrink: 0;
  margin: 0;
}

/* 服务卡片样式 - 门诊协作、购药商城、健康查一查、健康咨询 */
.service-card-outpatient {
  width: 151px;
  height: 92px;
  background: url('~@/assets/serviceImg/service/Frame_4262@2x.png') no-repeat center;
  background-size: 100% 100%;
  border-radius: 20px;
  padding: 0;
  margin: 0;
  position: relative;
  overflow: hidden;
}

.service-card-pharmacy {
  width: 151px;
  height: 92px;
  background: url('~@/assets/serviceImg/service/Frame_4263@2x.png') no-repeat center;
  background-size: 100% 100%;
  border-radius: 20px;
  padding: 0;
  margin: 0;
  position: relative;
  overflow: hidden;
}

.service-card-checkup {
  width: 151px;
  height: 92px;
  background: url('~@/assets/serviceImg/service/Frame_4264@2x.png') no-repeat center;
  background-size: 100% 100%;
  border-radius: 20px;
  padding: 0;
  margin: 0;
  position: relative;
  overflow: hidden;
}

.service-card-consultation {
  width: 151px;
  height: 92px;
  background: url('~@/assets/serviceImg/service/Frame_4265@2x.png') no-repeat center;
  background-size: 100% 100%;
  border-radius: 20px;
  padding: 0;
  margin: 0;
  position: relative;
  overflow: hidden;
}

.service-card-content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  z-index: 1;
}

.service-card-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 74px;
  align-items: flex-start;
  text-align: left;
  margin: 0;
}

.service-card-title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #333333;
  margin: 0;
  line-height: 1.2;
  word-wrap: break-word;
  word-break: break-all;
  text-align: left;
}

.service-card-desc {
  font-size: 12px;
  color: #999999;
  margin: 0;
  line-height: 1.4;
  word-wrap: break-word;
  word-break: break-all;
  text-align: left;
}

/* 出行救援服务网格 */
.rescue-services-grid {
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
  padding: 0;
}

.rescue-service-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.rescue-service-item:active {
  transform: scale(0.95);
  opacity: 0.9;
}

.rescue-service-icon {
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.rescue-service-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.rescue-service-label {
  font-size: 12px;
  color: #333333;
  text-align: center;
  line-height: 1.4;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
.modal {

  position: fixed;
  z-index: 1000000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,0.4);
}
.modal-content {
  background-color: #fefefe;
  padding: 8% 5%;
  border-radius: 12px 12px 0px 0px;
  position: absolute;
  bottom: 0;
  width: 100%;
  line-height: 0;
}
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}
.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
/* 悬浮一键救援按钮样式 */
.rescue-float-btn {
  position: fixed;
  left: 50%;
  margin-left: -6vh;
  width: 12vh;
  height: 12vh;
  min-width: 60px;
  min-height: 60px;
  bottom: 75px;
  z-index: 111111;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 50%;
  background: linear-gradient(135deg, #42D764 0%, #0C962A 100%);
  box-shadow: 0 4px 20px rgba(66, 215, 100, 0.4), 0 0 0 4px rgba(66, 215, 100, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: heartbeat 1s infinite;
}

.rescue-float-btn:active {
  transform: scale(0.95);
  box-shadow: 0 2px 10px rgba(66, 215, 100, 0.3), 0 0 0 2px rgba(66, 215, 100, 0.1);
}

.rescue-btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2px;
}

.rescue-icon-heart {
  font-size: 18px;
  color: #ffffff;
  font-weight: bold;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  line-height: 1;
  /* min-font-size: 24px; */
  /* font-size: clamp(20px, 2.5vh, 28px); */
}

.rescue-btn-text {
  font-size: 1.2vh;
  color: #ffffff;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  line-height: 1;
  min-font-size: 12px;
  font-size: clamp(10px, 1.2vh, 14px);
  letter-spacing: 0.5px;
}

@keyframes heartbeat {
  0% {
    transform: scale(1);
    opacity: 1;
    box-shadow: 0 4px 20px rgba(66, 215, 100, 0.4), 0 0 0 4px rgba(66, 215, 100, 0.1);
  }
  50% {
    transform: scale(1.1);
    opacity: 0.9;
    box-shadow: 0 6px 30px rgba(66, 215, 100, 0.6), 0 0 0 8px rgba(66, 215, 100, 0.15);
  }
  100% {
    transform: scale(1);
    opacity: 1;
    box-shadow: 0 4px 20px rgba(66, 215, 100, 0.4), 0 0 0 4px rgba(66, 215, 100, 0.1);
  }
}
.ContentTitle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;

  color: #333333;
  line-height: 15px;
  text-align: justify;
  font-style: normal;
}
.Consultation {
  width: 150px;
  height: 100px;
  padding: 13px;
  background: url('~@/assets/serviceImg/Consultation.png') center no-repeat;
  background-size: 100%;
}
.jkzx {
  width: 100%;
  height: 100px;
  padding: 10px;
  background-size: 100%;
  border-radius: 13px;
  background-color:#ffffff
}
.gysc {
  width: 165px;
  height: 100px;
  padding: 18px;
  background: url('~@/assets/serviceImg/gysc.png') center no-repeat;
  background-size: 100%;
  float: right;
  margin-left: 10px;
}

.outpatientservice {
  width: 165px;
  height: 100px;
  background: url('~@/assets/serviceImg/outpatientservice.png') center no-repeat;
  background-size: 100%;
  padding: 18px;
  float: left;
}
.smoke-prize {
  width: 90%;
  background: #ffffff;
  border-radius: 20px;
  padding: 15px 15px;
  margin-top: 15px;
}
.text {
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 13px;
color: #00C275;
margin: 18px 0;
text-align: center;
font-style: normal;
}

/* 一键救援卡片样式 */
.rescue-card-container {
  width: 90%;
  margin: 0px 15px 15px auto;
  background: #ffffff;
  border-radius: 20px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.rescue-icon-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
}

.rescue-icon {
  width: auto;
  height: auto;
  max-width: 120px;
  max-height: 120px;
  object-fit: contain;
}

.rescue-status-text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  margin-bottom: 16px;
  text-align: center;
}

.rescue-button-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.rescue-button-wrapper:active {
  transform: scale(0.98);
  opacity: 0.9;
}

.rescue-button-bg {
  width: 100%;
  max-width: 100%;
  height: auto;
  display: block;
}

.rescue-button-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
  white-space: nowrap;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  letter-spacing: 2px;
}

.rescue-desc-text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #00B100;
  text-align: center;
  line-height: 1.5;
}
.tit {
  width: 8px;
  height: 20px;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  border: 1px solid transparent;
  border-radius: 13px;
  display: inline-block;
  box-shadow: 0 2px 4px rgba(0, 194, 117, 0.2);
}
.titspan {
  margin-left:10px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 18px;
  color: #333333;
  text-align: justify;
  font-style: normal;
}
/* 服务页面头部 */
.service-header {
  margin-bottom: 0;
  background: url('~@/assets/serviceImg/service/Frame 3424@2x.png') no-repeat center top;
  background-size: 100% auto;
  background-color: #f8f9fa;
  padding-top: 24px;
}

.service-header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  margin-bottom: 0;
}

.service-title {
  color: #000;
  font-weight: bold;
  font-size: 18px;
  text-align: left;
  flex: 0 0 auto;
  margin: 0;
}

.kefu-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 0 0 auto;
  margin: 0;
  &:hover {
    opacity: 0.8;
  }
  
  &:active {
    transform: scale(0.95);
  }
}

.kefu-icon {
  width: 26px;
  height: 26px;
  flex: 0 0 auto;
  margin: 0;
}

.kefu-text {
  font-size: 14px;
  color: #000;
  font-weight: 500;
  white-space: nowrap;
}

.service-header-content {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 20px 16px 20px;
  margin-bottom: 0;
  min-height: 48px;
}

/* 客服按钮样式 - 参考首页 device-management 样式 */
.customer-service-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  transition: all 0.3s ease;
  flex: 0 0 auto;
  margin-left: auto;
  position: absolute;
  right: 0px;
  img {
    width: 28px;
    height: 28px;
    display: block;
    position: absolute;
    right: 20px;
    transition: transform 0.3s ease;
  }
  
  &:hover {
    background: rgba(255, 255, 255, 0.15);
    
    img {
      transform: scale(1.1);
    }
  }
  
  &:active {
    img {
    transform: scale(0.95);
  }
  }
}

.klfwtit {
  margin: 15px 15px 0px 18px;
  display: flex;
  align-items: center;
  float: left;
}
.prize2 {
  padding: 8px 0;display: flex;align-items: center;margin-top: 15px;
}
.prize2Img {
  width: 30px;margin-left:17px
}
.prize2Title {
  font-size:16px;line-height: 13px;
}
.prizeqzx {
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  border-radius: 16px;
  color: #ffffff;
  padding: 6px 12px;
  font-size: 12px;
  box-shadow: 0 2px 6px rgba(0, 194, 117, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:active {
    transform: scale(0.95);
    box-shadow: 0 1px 3px rgba(0, 194, 117, 0.3);
  }
}
.cxjyfw {
  height:42px;margin-top: 10px;
}

/* 在线医生模块样式 */
.online-doctor-module {
  width: 90%;
  background: #ffffff;
  border-radius: 12px;
  padding: 9px;
  margin: 0 auto 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 标题区域 */
.doctor-module-header {
  width: 100%;
  margin-bottom: 0;
}

.doctor-module-title {
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: flex-start;
}

.doctor-module-title .titspan {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  text-align: justify;
  font-style: normal;
}

.doctor-module-title .doctor-time {
  font-size: 11px;
  font-weight: normal;
  color: #ffffff;
  background: rgba(0, 177, 0, 0.5);
  padding: 3px 10px;
  border-radius: 12px;
  margin-left: 10px;
}

/* 卡片区域 */
.doctor-cards-wrapper {
  display: flex;
  gap: 12px;
  align-items: stretch;
}

/* 其他地方的doctor-time样式保持不变，仅在线医生模块内的使用上面的样式 */

/* 图文医生 - 左侧大卡片 */
  .doctor-main-card {
  flex: 0 0 auto;
  position: relative;
  border-radius: 12px;
    cursor: pointer;
  overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 194, 117, 0.3);
  transition: all 0.3s ease;
  width: 158px;
  height: 143px;
  display: flex;
  align-items: stretch;
}

.doctor-main-card:active {
  transform: scale(0.98);
  opacity: 0.9;
}

.doctor-main-card-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.doctor-main-card-content {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 12px;
}

.doctor-main-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  width: 100%;
}

.doctor-type {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #333333;
  margin: 0;
  line-height: 1.2;
}

.doctor-specialty {
  font-size: 12px;
  color: #00B100;
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 2px 0;
  line-height: 1.2;
}

.doctor-checkmark {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  text-align: center;
  line-height: 14px;
  font-size: 10px;
  font-weight: bold;
}

.green-checkmark {
  background: #00B100;
  color: #ffffff;
}

.blue-checkmark {
  background: #4A90E2;
  color: #ffffff;
}

/* 视频医生对勾颜色 */
.doctor-card:first-child .blue-checkmark {
  background: #598DF7;
}

/* 电话医生对勾颜色 */
.doctor-card:last-child .blue-checkmark {
  background: #12A8FF;
}

.doctor-action-btn {
  align-self: flex-start;
  width: 48px;
  height: 16px;
  padding: 0;
  padding-left: 8px;
  padding-right: 2px;
  border-radius: 16px;
  font-size: 10px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
  text-align: center;
  line-height: 16px;
  box-sizing: border-box;
}

.doctor-btn-arrow {
  width: auto;
  height: 10px;
  display: inline-block;
  object-fit: contain;
  margin-right: 0;
  flex-shrink: 0;
}

.green-btn {
  background: #00B100;
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 177, 0, 0.2);
}

.blue-btn {
  background: linear-gradient(135deg, #4A90E2 0%, #6BB3FF 100%);
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(74, 144, 226, 0.2);
}

/* 视频医生按钮颜色 */
.doctor-card:first-child .blue-btn {
  background: #598DF7;
  box-shadow: 0 2px 6px rgba(89, 141, 247, 0.2);
}

/* 电话医生按钮颜色 */
.doctor-card:last-child .blue-btn {
  background: #12A8FF;
  box-shadow: 0 2px 6px rgba(18, 168, 255, 0.2);
}

.doctor-action-btn:active {
  transform: scale(0.95);
}

/* 右侧两个小卡片容器 */
.doctor-right-cards {
  flex: 0 0 48%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 视频医生和电话医生卡片 */
  .doctor-card {
  flex: 0 0 auto;
  position: relative;
  border-radius: 12px;
    cursor: pointer;
  overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  width: 145px;
  height: 66px;
  display: flex;
  align-items: stretch;
}

.doctor-card:active {
  transform: scale(0.98);
  opacity: 0.9;
}

.doctor-card-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.doctor-card-content {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 8px;
  padding-left: 45%;
}

.doctor-card-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;
  width: 100%;
}

.doctor-card-type {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 13px;
  color: #333333;
  margin: 0;
  line-height: 1.2;
}

.doctor-card-specialty {
  font-size: 11px;
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 1px 0;
  line-height: 1.2;
}

/* 视频医生全科文字颜色 */
.doctor-card:first-child .doctor-card-specialty {
  color: #598DF7;
}

/* 电话医生全科文字颜色 */
.doctor-card:last-child .doctor-card-specialty {
  color: #12A8FF;
  }

/* 私人医生模块样式 */
.private-doctor-banner {
  width: 90%;
  height: 66px;
  margin: 15px auto;
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.private-doctor-banner:active {
  transform: scale(0.98);
  opacity: 0.9;
}

.private-doctor-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.private-doctor-content {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.private-doctor-doctor-img {
  width: 64px;
  height: 59px;
  object-fit: contain;
  flex-shrink: 0;
}

.private-doctor-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  text-align: left;
  padding-left: 15px;
}

.private-doctor-title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #333333;
  margin: 0;
  line-height: 1.2;
  text-align: left;
}

.private-doctor-desc {
  font-size: 11px;
  color: #999999;
  margin: 0;
  line-height: 1.2;
  text-align: left;
}

.private-doctor-btn-wrapper {
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 68px;
  height: 29px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.private-doctor-btn-wrapper:active {
    transform: scale(0.95);
}

.private-doctor-btn-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.private-doctor-btn-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 12px;
  font-weight: 500;
  color: #ffffff;
  white-space: nowrap;
}

.private-doctor-btn-arrow {
  width: auto;
  height: 10px;
  display: inline-block;
  object-fit: contain;
}

/* 私人医生弹窗样式 - 确保弹框在页面中间显示 */
.private-doctor-dialog.van-dialog {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  margin: 0 !important;
  max-width: 90% !important;
  width: auto !important;
  min-width: 300px !important;
}

/* 弹框遮罩层 */
.van-overlay {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 2000 !important;
}

.private-doctor-dialog .van-dialog__header {
  padding: 20px 20px 10px;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  position: relative;
  border-bottom: none;
}

.private-doctor-dialog .private-doctor-content {
  padding: 0 20px 20px;
  text-align: center;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.private-doctor-close {
  position: absolute;
  right: 16px;
  top: 16px;
  font-size: 28px;
  color: #999;
  z-index: 100;
  cursor: pointer;
  font-weight: bold;
  line-height: 1;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s ease;
  background: transparent;
  border: none;
  padding: 0;
}

.private-doctor-close:hover {
  color: #333;
}

.private-doctor-dialog .qr-code-container {
  margin: 0 auto 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.private-doctor-dialog .qr-code {
  width: 200px;
  height: 200px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  object-fit: contain;
  background: #fff;
  display: block;
  margin: 0 auto;
}

.private-doctor-dialog .instruction-text {
  font-size: 14px;
  color: #666666;
  line-height: 1.6;
  margin: 0 auto 24px;
  text-align: center;
  padding: 0 10px;
  width: 100%;
  box-sizing: border-box;
}

.private-doctor-dialog .action-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0;
}

.private-doctor-dialog .action-btn {
  flex: 1;
  max-width: 140px;
  min-width: 100px;
  height: 44px;
  border-radius: 22px;
  font-size: 15px;
  transition: all 0.3s ease;
  font-weight: 500;
}

.private-doctor-dialog .action-btn:active {
  transform: scale(0.98);
  opacity: 0.9;
}

.save-btn {
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  border-color: transparent;
  box-shadow: 0 2px 8px rgba(0, 194, 117, 0.3);
  
  &:active {
    transform: scale(0.95);
    box-shadow: 0 1px 4px rgba(0, 194, 117, 0.4);
  }
}

.share-btn {
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  border-color: transparent;
  box-shadow: 0 2px 8px rgba(0, 194, 117, 0.3);
  
  &:active {
    transform: scale(0.95);
    box-shadow: 0 1px 4px rgba(0, 194, 117, 0.4);
  }
}


</style>






// WEBPACK FOOTER //
// src/views/service/newIndex.vue